// Claude: Seller RFX Detail — wired to GET /rfx/:id + PATCH /:id/interested + PATCH not-interested 24-02-2026; Confirm Interest + Cancel added 24-04-2026
// Claude: buyer digital assets shown in profile modal 25-02-2026
// Claude: Set up a Meeting wired to CreateMeetModal — mirrors buyer RFXResponses pattern 26-02-2026
// Claude: N22 — isLocked extended for admin_review/admin_unpublished; Report RFX button added 03-03-2026
// Claude: interested is now terminal — response text opened locally after confirm; no withdraw; no edit after submit 18-04-2026
// Claude: drawer + modals extracted to BuyerProfileDrawer + RfxDetailModals 18-04-2026
import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Image,
  Badge,
  HStack,
  Button,
  Textarea,
  Divider,
  VStack,
} from "@chakra-ui/react";
import { Modal } from "antd";
import { Images } from "../../Assets/images";
import { MdOutlineArrowBack, MdOutlineAccessTime } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/Actions";
import { Sellerscreens } from "../../Constants/data";
import { RfxAPI } from "../../Apis/rfxAPI";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { CommonAPI } from "../../Apis/commonApi";
import { SellerAPI } from "../../Apis/sellerAPI";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { isNewMeetingAllowed } from "../../Utils/meetingUtils";
import { errorHandler } from "../../Utils/handler";
import moment from "moment";
import Loader from "../../Components/Loader/Loader";
import BuyerProfileDrawer from "../../Components/Common/BuyerProfileDrawer";
import RfxDetailModals from "../../Components/Modals/RfxDetailModals";

const RFXDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { error, success: toastSuccess } = useToastWrapper();
  const user = useSelector((state: any) => state.user);

  const rfxId = (location.state as { rfxId?: string; humanRfxId?: string; isPlanActive?: boolean } | null)?.rfxId ?? "";
  const humanRfxId = (location.state as { rfxId?: string; humanRfxId?: string; isPlanActive?: boolean } | null)?.humanRfxId ?? "";
  const isPlanActive = (location.state as { rfxId?: string; humanRfxId?: string; isPlanActive?: boolean } | null)?.isPlanActive; // Claude: plan gate for meeting setup 11-04-2026
  const [rfx, setRfx] = useState<any>(null);
  const [myResponse, setMyResponse] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [responseText, setResponseText] = useState("");
  // Claude: buyer profile drawer state 02-Apr-2026
  const [profileOpen, setProfileOpen] = useState(false);
  const [buyerProfile, setBuyerProfile] = useState<any>(null);
  const [buyerAssets, setBuyerAssets] = useState<any[]>([]);
  const [profileLoading, setProfileLoading] = useState(false);
  const [notesBody, setNotesBody] = useState<string>("");
  // Claude: verification gate modal 03-03-2026
  const [verifyGateOpen, setVerifyGateOpen] = useState(false);
  // Claude: N22 — report RFX modal state 03-03-2026
  const [reportOpen, setReportOpen] = useState(false);
  const [reportReason, setReportReason] = useState("");
  const [reportLoading, setReportLoading] = useState(false);
  // Claude: local state — opens response text area after seller confirms interest 18-04-2026
  const [showResponseArea, setShowResponseArea] = useState(false);
  // Claude: submit warning modal — shown once before first submission 18-04-2026
  const [submitWarningOpen, setSubmitWarningOpen] = useState(false);

  // Claude: Save Buyer to List state 26-02-2026
  const [buyerSaved, setBuyerSaved] = useState(false);
  const handleSaveBuyer = async () => {
    try {
      const buyerId = rfx?.buyerId?._id;
      if (!buyerId) return;
      await SellerAPI.addNewBuyerToList({ buyerId, source: "rfx" });
      setBuyerSaved(true);
      toastSuccess("Buyer added to your list.");
    } catch (err: any) {
      error(errorHandler(err));
    }
  };

  // Meeting state — mirrors RFXResponses / SellersList pattern
  const [meetingData, setMeetingData] = useState<any>({});
  const [meetModal, setMeetModal] = useState(false);
  const [meetResponder, setMeetResponder] = useState<any>(null);
  const [meetConfirm, setMeetConfirm] = useState(false);
  const [currentMeet, setCurrentMeet] = useState("");

  const handleOpenMeetModal = () => setMeetModal(true);
  // Claude: refresh meetingData after modal closes so duplicate check is accurate 04-03-2026
  const handleCloseMeetModal = () => { setMeetModal(false); fetchMeetings(); };
  const handleOpenMeetConfirmModal = () => setMeetConfirm(true);
  const handleCloseMeetConfirmModal = () => setMeetConfirm(false);


  // Claude: fetch only meetings — called on mount and after CreateMeetModal closes 04-03-2026
  const fetchMeetings = async () => {
    try {
      const meetRes = await CommonAPI.GetMeeting({ status: undefined });
      if (meetRes) {
        const meetings = JSON.parse(JSON.stringify(meetRes.data.data));
        const meetObj: any = {};
        meetings.forEach((element: any) => {
          const temp = {
            _id: element._id,
            requesterId: element.requesterId,
            responderId: element.responderId,
            requesterStatus: element.requesterStatus,
            responderStatus: element.responderStatus,
          };
          meetObj[element.responderCompany] = temp;
        });
        setMeetingData(meetObj);
      }
    } catch (err) {
      error(errorHandler(err));
    }
  };

  // Claude: backend returns { rfx, myResponse } — unwrap correctly 25-02-2026
  const fetchDetail = async () => {
    if (!rfxId) return;
    setLoading(true);
    try {
      const [rfxRes, meetRes] = await Promise.all([
        RfxAPI.getRfxDetail(rfxId),
        CommonAPI.GetMeeting({ status: undefined }),
      ]);
      const data = rfxRes?.data;
      setRfx(data?.rfx ?? null);
      setMyResponse(data?.myResponse ?? null);
      // Claude: initialise buyerSaved from backend isInList flag 04-03-2026
      if (data?.isInList) setBuyerSaved(true);
      if (data?.myResponse?.rfxResponseDetails) {
        setResponseText(data.myResponse.rfxResponseDetails);
      }
      if (meetRes) {
        const meetings = JSON.parse(JSON.stringify(meetRes.data.data));
        const meetObj: any = {};
        meetings.forEach((element: any) => {
          const temp = {
            _id: element._id,
            requesterId: element.requesterId,
            responderId: element.responderId,
            requesterStatus: element.requesterStatus,
            responderStatus: element.responderStatus,
          };
          meetObj[element.responderCompany] = temp;
        });
        setMeetingData(meetObj);
      }
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(actions.sellerMenu.set({
      activeMenu: Sellerscreens.RFX,
      aiChatContext: "rfx-detail",
    }));
    fetchDetail();
  }, []);

  const responseStatus: string = myResponse?.sellerResponseStatus ?? "pending";
  const isRfxClosed = rfx?.status === "closed";
  // Claude: interested added to locked — text is final after submission 18-04-2026; revision_requested stays unlocked
  const isLocked = ["not_interested", "interested", "admin_review", "admin_unpublished"].includes(responseStatus) || isRfxClosed;
  // Claude: show response area if locally confirmed OR revision_requested (skip re-confirm) 18-04-2026
  const canShowResponseArea = showResponseArea || responseStatus === "revision_requested";

  // Claude: not interested — confirmation gate; preference is final 10-04-2026
  const handleNotInterested = () => {
    Modal.confirm({
      title: "Mark as Not Interested?",
      content: "Once set, this preference cannot be changed. The buyer will not be able to see your profile for this opportunity.",
      okText: "Continue",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          await RfxAPI.markNotInterested(rfxId);
          fetchDetail();
        } catch (err) {
          error(errorHandler(err));
        }
      },
    });
  };

  // Claude: interested — confirm modal opens response text area locally; no API call yet 18-04-2026
  const handleMarkInterested = () => {
    Modal.confirm({
      title: "Mark as Interested?",
      content: "Once confirmed, this cannot be changed. Your response will be visible to the buyer.",
      okText: "Continue",
      cancelText: "Cancel",
      onOk: () => setShowResponseArea(true),
    });
  };

  // Claude: cancel response form — revert to pending state 24-04-2026
  const handleCancelResponse = () => {
    setShowResponseArea(false);
    setResponseText("");
  };

  // Claude: actual submit — called after warning modal confirm 18-04-2026
  const doSubmit = async () => {
    setSubmitWarningOpen(false);
    if (["unverified", "resubmitted"].includes(user?.verificationStatus)) { setVerifyGateOpen(true); return; }
    if (user?.verificationStatus === "provisional") { error("Profile is pending review and has provisional access only."); return; }
    setLoading(true);
    try {
      await RfxAPI.markInterested(rfxId, responseText);
      navigate("/seller/rfxs", { state: { submittedId: rfxId } });
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  // Claude: submit button tap — show warning modal first 18-04-2026
  const handleSubmit = () => {
    if (["unverified", "resubmitted"].includes(user?.verificationStatus)) { setVerifyGateOpen(true); return; }
    if (user?.verificationStatus === "provisional") { error("Profile is pending review and has provisional access only."); return; }
    setSubmitWarningOpen(true);
  };

  // Claude: buyer profile drawer — fetch assets + notes on open 02-Apr-2026
  const fetchBuyerNotes = async (buyerId: string) => {
    try {
      const res = await CommonAPI.getNotes({ forUser: buyerId });
      setNotesBody(res?.data?.data?.body ?? "");
    } catch { setNotesBody(""); }
  };

  const handleViewProfile = async () => {
    if (!rfx?.buyerId) return;
    setBuyerProfile(rfx.buyerId);
    setBuyerAssets([]);
    setNotesBody("");
    setProfileOpen(true);
    setProfileLoading(true);
    try {
      const [assetsRes] = await Promise.all([
        BuyerAPI.getBuyerAssets(rfx.buyerId._id),
        fetchBuyerNotes(rfx.buyerId._id),
      ]);
      setBuyerAssets(Array.isArray(assetsRes?.data) ? assetsRes.data : (Array.isArray(assetsRes) ? assetsRes : []));
    } catch {} finally { setProfileLoading(false); }
  };


  // Claude: N22 — seller reports an RFX 03-03-2026
  const handleReportRfx = async () => {
    setReportLoading(true);
    try {
      await RfxAPI.reportRfx(rfxId, reportReason.trim());
      setReportOpen(false);
      setReportReason("");
      toastSuccess("Report submitted. Our team will review the RFX.");
      // Refresh so status updates on-screen
      await fetchDetail();
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setReportLoading(false);
    }
  };

  // Claude: Set up a Meeting — mirrors RFXResponses / SellersList meet button logic 26-02-2026
  const handleSetupMeeting = () => {
    // Claude: gate for inactive plan — show warning immediately before opening modal 11-04-2026
    if (isPlanActive === false) {
      Modal.warning({ title: "Alert!", content: "Subscription limits reached. Please renew to continue." });
      return;
    }
    // Claude: gate for unverified/resubmitted sellers 03-03-2026
    if (["unverified", "resubmitted"].includes(user?.verificationStatus)) { setVerifyGateOpen(true); return; }
    const companyName = rfx?.buyerId?.buyerCompanyName;
    if (meetingData[companyName]) {
      const meetingObj = meetingData[companyName];
      const status =
        user.user === meetingObj.requesterId
          ? meetingObj.requesterStatus
          : meetingObj.responderStatus;
      if (isNewMeetingAllowed(status)) {
        setMeetResponder(rfx.buyerId);
        handleOpenMeetModal();
      } else {
        setCurrentMeet(meetingObj._id);
        handleOpenMeetConfirmModal();
      }
    } else {
      setMeetResponder(rfx.buyerId);
      handleOpenMeetModal();
    }
  };

  return (
    <Box w="100%">
      {/* Header */}
      <Flex
        w="100%"
        px="20px"
        py={5}
        bg="#0E122F"
        color="white"
        alignItems="center"
        gap={3}
      >
        <MdOutlineArrowBack
          size={22}
          color="white"
          cursor="pointer"
          onClick={() => navigate("/seller/rfxs")}
        />
        {/* Claude: N2 — show rfxId from nav state immediately; falls back to fetched rfx 26-02-2026 */}
        <Text fontSize="lg" fontWeight={700} flex={1}>{humanRfxId || rfx?.rfxId || "RFX Detail"}</Text>
        {/* Claude: role label below logo in header 25-02-2026 */}
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="28px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            seller (beta)
          </Text>

        </VStack>
      </Flex>

      <Box
        w="100%"
        px="20px"
        pb="30px"
        background="linear-gradient(180deg, #FFF5EE 0%, #FFFFFF 100%)"
        minH="100dvh"
        position="relative"
      >
        {loading && <Loader />}

        {/* RFX snippet card */}
        {rfx && (
          <Box
            mt={5}
            p="16px"
            border="1px solid #D2D2D2"
            borderRadius="15px"
            bg="white"
            shadow="sm"
          >
            <Text fontSize="sm" color="gray.700" lineHeight="1.6">
              {rfx.rfxDetails}
            </Text>
            {/* Claude: department + tags fine print 17-Apr-2026 */}
            {(() => {
              const depts = (rfx.departments ?? []).map((d: any) => (typeof d === "object" ? d.name : d));
              const tags: string[] = rfx.targetTags ?? [];
              const parts = [
                depts.length > 0 ? `Dept: ${depts.join(", ")}` : null,
                tags.length > 0 ? `Tags: ${tags.join(", ")}` : null,
              ].filter(Boolean);
              return parts.length > 0 ? (
                <Text fontSize="10px" color="gray.400" mt={1}>{parts.join("  ·  ")}</Text>
              ) : null;
            })()}
            {/* Claude: show only company name; click opens right-side drawer 02-Apr-2026 */}
            <Text
              fontSize="11px"
              color="#7C66FF"
              mt={1}
              cursor="pointer"
              textDecoration="underline"
              onClick={handleViewProfile}
            >
              {rfx.buyerId?.buyerCompanyName}
            </Text>
            <HStack mt={2} spacing={1}>
              <MdOutlineAccessTime size={11} color="#aaa" />
              <Text fontSize="11px" color="gray.400">
                Expires {moment(rfx.expiryDate).format("DD MMM YYYY")}
              </Text>
            </HStack>
            {/* Claude: show buyer's close reason when RFX is closed 02-Apr-2026 */}
            {rfx.status === "closed" && rfx.closeReason && (
              <Box mt={2} p={2} bg="#FFF8E1" borderRadius="6px" border="1px solid #FFE082">
                <Text fontSize="11px" color="orange.700" lineHeight="1.5">
                  Closed: {rfx.closeReason}
                </Text>
              </Box>
            )}
          </Box>
        )}

        {/* Claude: action buttons below RFX content 04-03-2026 */}
        {rfx && (
          <>
          {/* Claude: help text moved above buttons 24-04-2026 */}
          {responseStatus === "pending" && !isRfxClosed && (
            <Text fontSize="10px" color="gray.400" mt={3} mb={2}>
              Your profile and digital assets are shown to the buyer only when you click Interested. If you click Not Interested, your profile will not be shown to the buyer for this enquiry. In either case, once set, your preference cannot be changed for this opportunity.
            </Text>
          )}
          <HStack mt={1} spacing={2} flexWrap="wrap">
            {/* Claude: Interested always shown when pending; Not Interested + Report RFX hidden when form open 24-04-2026 */}
            {responseStatus === "pending" && !isRfxClosed && (
              <>
                <Button
                  size="sm" bg="#2E7D32" color="white" h="34px" fontSize="12px"
                  _hover={{ bg: "#1B5E20" }}
                  isDisabled={showResponseArea}
                  onClick={handleMarkInterested}
                >
                  Interested
                </Button>
                {!showResponseArea && (
                  <Button
                    size="sm" bg="#C62828" color="white" h="34px" fontSize="12px"
                    _hover={{ bg: "#B71C1C" }}
                    onClick={handleNotInterested}
                  >
                    Not Interested
                  </Button>
                )}
              </>
            )}
            {/* Claude: static badges once interest is set 18-04-2026 */}
            {responseStatus === "interested" && (
              <Badge px={3} py={1} borderRadius="md" fontSize="11px" textTransform="none" colorScheme="green">
                Interested
              </Badge>
            )}
            {responseStatus === "not_interested" && (
              <Badge px={3} py={1} borderRadius="md" fontSize="11px" textTransform="none" colorScheme="red">
                Not Interested
              </Badge>
            )}
            <Button
              size="sm" variant="outline"
              color={buyerSaved ? "#2E7D32" : "gray.600"}
              borderColor={buyerSaved ? "#2E7D32" : "gray.300"}
              h="34px" fontSize="12px"
              isDisabled={buyerSaved}
              _hover={{ bg: "#2E7D32", color: "white", borderColor: "#2E7D32" }}
              onClick={handleSaveBuyer}
            >
              {buyerSaved ? "Buyer already added." : "Save Buyer to List"}
            </Button>
            {responseStatus === "interested" && (
              <Button
                size="sm" variant="outline" color="gray.600" borderColor="gray.300" h="34px" fontSize="12px"
                _hover={{ bg: "#2E7D32", color: "white", borderColor: "#2E7D32" }}
                onClick={handleSetupMeeting}
              >
                Set up a Meeting
              </Button>
            )}
            {rfx?.status === "open" && responseStatus !== "admin_unpublished" && !showResponseArea && (
              <Button
                size="sm" variant="outline" color="gray.600" borderColor="gray.300" h="34px" fontSize="12px"
                _hover={{ bg: "#C62828", color: "white", borderColor: "#C62828" }}
                onClick={() => setReportOpen(true)}
              >
                Report RFX
              </Button>
            )}
          </HStack>
          </>
        )}

        {/* Response section */}
        {/* Claude: status badges + explanations 24-02-2026; submitted removed 18-04-2026 */}
        {responseStatus !== "pending" && (
          <>
            {!["interested", "not_interested"].includes(responseStatus) && (
              <Badge
                mb={2}
                colorScheme={
                  responseStatus === "revision_requested" ? "orange" :
                  responseStatus === "admin_review" ? "yellow" :
                  responseStatus === "admin_unpublished" ? "red" : "gray"
                }
                textTransform="none" fontSize="12px" px={3} py={1} borderRadius="6px"
              >
                {responseStatus === "revision_requested" ? "Revision Requested" :
                 responseStatus === "admin_review" ? "Response Under Review" :
                 responseStatus === "admin_unpublished" ? "Response Removed" : ""}
              </Badge>
            )}
            {responseStatus === "interested" && (
              <Badge mb={2} colorScheme="green" textTransform="none" fontSize="12px" px={3} py={1} borderRadius="6px">
                Response Submitted
              </Badge>
            )}
            {responseStatus === "revision_requested" && (
              <Text fontSize="12px" color="#C05621" mb={3}>
                A revised submission is requested. Additional and/or more specific details may be included.
              </Text>
            )}
            {responseStatus === "admin_review" && (
              <Text fontSize="12px" color="#B7791F" mb={3}>
                This response is currently under review and will be restored once cleared.
              </Text>
            )}
            {responseStatus === "admin_unpublished" && (
              <Text fontSize="12px" color="#C62828" mb={3}>
                This response was removed following a review for non-compliance with platform guidelines.
              </Text>
            )}
          </>
        )}

        {/* Claude: response area — shown only after confirming interest or on revision_requested 18-04-2026 */}
        {canShowResponseArea && (
          <>
            <Text fontSize="sm" mt={5} mb={1}>Add a cover note to your response</Text>
            <Text fontSize="11px" color="gray.500" mb={3}>
              Please provide an introductory response to support your initial interest — something like your relevant experience, scale, or a past success.
            </Text>
            <Textarea
              placeholder='e.g. "We have delivered similar projects for 5+ clients — reducing costs by 30% within 3 months of deployment."'
              fontSize="13px"
              borderRadius="10px"
              rows={4}
              resize="none"
              isDisabled={isLocked}
              bg={isLocked ? "#F7F7F7" : "white"}
              border="1px solid #D2D2D2"
              _placeholder={{ color: "gray.400" }}
              value={responseText}
              maxLength={500}
              onChange={(e) => setResponseText(e.target.value)}
            />
            <Text fontSize="10px" color={responseText.length >= 500 ? "#C62828" : "gray.400"} textAlign="right" mt={1}>
              {responseText.length}/500
            </Text>

            {/* Claude: Confirm Interest + Cancel; Cancel reverts to pending state 24-04-2026 */}
            {!isLocked && (
              <HStack mt={4} spacing={3} justifyContent="flex-end">
                <Button
                  size="sm" variant="outline" color="#0E122F" borderColor="#0E122F" h="36px" fontSize="12px"
                  _hover={{ bg: "gray.100" }}
                  onClick={handleCancelResponse}
                >
                  Cancel
                </Button>
                <Button
                  size="sm" bg="#2E7D32" color="white" h="36px" fontSize="12px"
                  isLoading={loading}
                  _hover={{ bg: "#1B5E20" }}
                  transition="none"
                  onClick={handleSubmit}
                >
                  Confirm Interest
                </Button>
              </HStack>
            )}
          </>
        )}
      </Box>

      {/* Claude: buyer profile drawer — extracted to BuyerProfileDrawer 18-04-2026 */}
      <BuyerProfileDrawer
        isOpen={profileOpen}
        onClose={() => setProfileOpen(false)}
        buyerProfile={buyerProfile}
        buyerAssets={buyerAssets}
        profileLoading={profileLoading}
        notesBody={notesBody}
        onNotesUpdated={() => { if (rfx?.buyerId?._id) fetchBuyerNotes(rfx.buyerId._id); }}
      />

      {/* Claude: all detail modals — extracted to RfxDetailModals 18-04-2026 */}
      <RfxDetailModals
        meetConfirm={meetConfirm}
        onCloseMeetConfirm={handleCloseMeetConfirmModal}
        currentMeet={currentMeet}
        meetModal={meetModal}
        onCloseMeetModal={handleCloseMeetModal}
        meetResponder={meetResponder}
        submitWarningOpen={submitWarningOpen}
        onCancelSubmit={() => setSubmitWarningOpen(false)}
        loading={loading}
        onConfirmSubmit={doSubmit}
        verifyGateOpen={verifyGateOpen}
        onCloseVerifyGate={() => setVerifyGateOpen(false)}
        reportOpen={reportOpen}
        onCloseReport={() => { setReportOpen(false); setReportReason(""); }}
        reportReason={reportReason}
        onReportReasonChange={setReportReason}
        reportLoading={reportLoading}
        onSubmitReport={handleReportRfx}
      />
    </Box>
  );
};

export default RFXDetail;
